import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "hitchFilled"
const HitchFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.126 15.38C20.909 15.47 22.327 16.944 22.327 18.75 22.327 20.614 20.817 22.125 18.952 22.125S15.576 20.614 15.576 18.75 17.088 15.375 18.952 15.375z" />
          <path d="M22.5 3.75H21.419C20.827 3.75 20.259 3.983 19.839 4.399L16.764 7.432H22.5V15.984C21.676 14.929 20.394 14.25 18.952 14.25 16.722 14.25 14.872 15.872 14.515 18H10.935C10.75 18.425 10.486 18.817 10.152 19.151 9.448 19.855 8.495 20.25 7.5 20.25S5.552 19.855 4.849 19.151C4.145 18.448 3.75 17.495 3.75 16.5H5.25C5.25 17.097 5.487 17.669 5.91 18.09 6.33 18.514 6.902 18.75 7.5 18.75S8.669 18.513 9.09 18.09Q9.253 17.93 9.376 17.744V13.313H11.25C11.56 13.313 11.813 13.06 11.813 12.75S11.56 12.188 11.25 12.188H9.375V10.057C9.375 8.607 10.55 7.432 12 7.432H14.63L18.783 3.33C19.486 2.638 20.433 2.25 21.42 2.25H22.5z" />
          <path d="M4.5 11.625C5.536 11.625 6.375 12.465 6.375 13.5S5.535 15.375 4.5 15.375 2.625 14.535 2.625 13.5 3.465 11.625 4.5 11.625" />
        </svg>
      }
    </span>
  )
}
export default HitchFilledIcon
